import TimeButton from "./TimeButton"
import '../styles/TimeBar.css'

const TimeBar = ({ onClick, activeTimeId }) => {
  const timeButtonIds = ['allTime', 'year', 'month', 'week'];
  return (
    <div className='timeBar'>
      <TimeButton text='All Time' onClick={onClick} timeButtonId={timeButtonIds[0]} className={
        `timeButton ${timeButtonIds[0] === activeTimeId ? 'buttonActive' : ''}`}/>

      <TimeButton text='Year' onClick={onClick} timeButtonId={timeButtonIds[1]} className={
        `timeButton ${timeButtonIds[1] === activeTimeId ? 'buttonActive' : ''}`}/>

      <TimeButton text='Month' onClick={onClick} timeButtonId={timeButtonIds[2]} className={
        `timeButton ${timeButtonIds[2] === activeTimeId ? 'buttonActive' : ''}`}/>

      <TimeButton text='Week' onClick={onClick} timeButtonId={timeButtonIds[3]} className={
        `timeButton ${timeButtonIds[3] === activeTimeId ? 'buttonActive' : ''}`}/>
    </div>
  )
}

export default TimeBar